/**
 * Enum representing the possible states of a survey card.
 */
export enum SurveyCardState {
  Enabled = 'enabled',
  Hovered = 'hovered',
  Disabled = 'disabled',
}
